module.exports = "/assets/d63d759d72b5042f9430bd96fc091cba.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/WH.png
// module id = 1960
// module chunks = 0